import { store } from './../store'

export const DC_LOAD_START  = 'DC_LOAD_START'
export const DC_LOAD_COMPLETE  = 'DC_LOAD_COMPLETE'
export const DC_LOAD_ERROR  = 'DC_LOAD_ERROR'
export const DC_LOAD_ABORD  = 'DC_LOAD_ABORD'
export const DC_CANCEL  = 'DC_CANCEL'



export const dcLoadStart = (payload) => {
  store.dispatch({type: DC_LOAD_START, payload})
}
export const dcLoadAbord = (payload) => {
  store.dispatch({type: DC_LOAD_ABORD, payload})
}
export const dcLoadComplete = (payload) => {
  store.dispatch({type: DC_LOAD_COMPLETE, payload})
}
export const dcLoadError = (payload) => {
  store.dispatch({type: DC_LOAD_ERROR, payload})
}
export const dcCancel = (payload) => {
  store.dispatch({type: DC_CANCEL, payload})
}
